function formatFromDate(d: Date): { date: string; time: string; full: string } {
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  const strHours = String(hours).padStart(2, '0');

  const date = `${day}-${month}-${year}`;
  const time = `${strHours}:${minutes} ${ampm}`;
  return { date, time, full: `${date} ${time}` };
}

export function splitDateTime(isoString?: string | null): { date: string; time: string; full: string } | null {
  if (!isoString) return null;
  try {
    const clean = String(isoString).trim();
    if (!clean) return null;

    // Date-only YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(clean)) {
      const [y, m, d] = clean.split('-');
      const date = `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
      return { date, time: '', full: date };
    }

    // DD/MM/YYYY
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(clean)) {
      const [d, m, y] = clean.split('/');
      const date = `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
      return { date, time: '', full: date };
    }

    // Already DD-MM-YYYY
    if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(clean)) {
      const [d, m, y] = clean.split('-');
      const date = `${d.padStart(2, '0')}-${m.padStart(2, '0')}-${y}`;
      return { date, time: '', full: date };
    }

    // Pass-through standard special strings
    if (clean === '—' || clean === 'N/A' || clean === 'Not known' || clean === 'Inaccessible' || clean === 'First time by us') {
      return { date: clean, time: '', full: clean };
    }

    const d = new Date(clean.endsWith('Z') || clean.includes('+') ? clean : `${clean}Z`);
    if (isNaN(d.getTime())) {
      const fallback = new Date(clean);
      if (isNaN(fallback.getTime())) return { date: isoString, time: '', full: isoString };
      return formatFromDate(fallback);
    }
    return formatFromDate(d);
  } catch {
    return { date: isoString, time: '', full: isoString };
  }
}

export function formatDateTime(isoString?: string | null): string {
  const parts = splitDateTime(isoString);
  return parts ? parts.full : '—';
}

export function formatDateOnly(isoString?: string | null): string {
  const parts = splitDateTime(isoString);
  return parts ? parts.date : '—';
}

export function formatDate(isoString?: string | null): string {
  const parts = splitDateTime(isoString);
  return parts ? (parts.date === '—' ? '' : parts.date) : '';
}
